var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMotorola(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.91 25.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed008e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo Motorola") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.31,0c.44.05.88.09,1.32.17A12.19,12.19,0,0,1,24.1,7.49,12.58,12.58,0,1,1,.21,14.83c-.09-.47-.12-.95-.18-1.42a1,1,0,0,0,0-.12V11.83c0-.28.06-.57.1-.85A12.58,12.58,0,0,1,10.56.17C11,.1,11.42.06,11.85,0ZM8.82,3.09,4,18.91c.25,0,.47,0,.68,0s.23,0,.27-.21A18.24,18.24,0,0,1,6.1,15.26a4.68,4.68,0,0,1,1.32-1.82,2.21,2.21,0,0,1,3.07.16,5.87,5.87,0,0,1,1.15,1.54c.32.61.62,1.23.94,1.86l.08-.16.55-1.16a7,7,0,0,1,1.46-2.1,2.14,2.14,0,0,1,2-.62,2.69,2.69,0,0,1,1.51,1,7.5,7.5,0,0,1,1.27,2.44c.27.79.48,1.6.72,2.39,0,.07.09.16.14.17.26,0,.51,0,.8,0L16.34,3.09,12.61,15.44h-.06L8.82,3.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.26,8.54a4.56,4.56,0,0,1,1.39-1.08,4.35,4.35,0,0,1,6.22,3.48c0,.19,0,.37,0,.56q0,3.09,0,6.17v.24H42.81v-.26q0-3.12,0-6.24a2.25,2.25,0,1,0-4.5,0c0,2.06,0,4.13,0,6.19v.26H36.23v-.25q0-3.12,0-6.24a2.25,2.25,0,1,0-4.5-.09c0,1.76,0,3.51,0,5.27v1.3H29.64V17.7c0-2.09,0-4.19,0-6.28A4.3,4.3,0,0,1,33.18,7.1a4.19,4.19,0,0,1,3.93,1.27l.15.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.89,17.58h-2V16.5l-.22.17a5.52,5.52,0,1,1,2.2-4.47c0,1.74,0,3.49,0,5.23,0,0,0,.08,0,.15m-2.06-5.3a3.47,3.47,0,1,0-3.48,3.45,3.48,3.48,0,0,0,3.48-3.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.82,18.07a5.52,5.52,0,1,1,5.53-5.54,5.54,5.54,0,0,1-5.53,5.54m0-2.06a3.46,3.46,0,1,0-3.45-3.47A3.47,3.47,0,0,0,51.82,16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.44,17.79A5.53,5.53,0,1,1,94,12.28a5.54,5.54,0,0,1-5.53,5.51m0-2.06A3.47,3.47,0,1,0,85,12.25a3.49,3.49,0,0,0,3.45,3.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.84,17.79a5.53,5.53,0,1,1,5.54-5.51,5.53,5.53,0,0,1-5.54,5.51m0-2.06a3.47,3.47,0,1,0-3.47-3.46,3.48,3.48,0,0,0,3.47,3.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.52,16v2.07a4.53,4.53,0,0,1-2-.27,4.32,4.32,0,0,1-2.8-4c0-3.1,0-6.2,0-9.3,0-.06,0-.11,0-.18h2.07V7h2.67V9.13H60.83v.23q0,2.15,0,4.31A2.24,2.24,0,0,0,63.17,16h.35"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 95.37,
    y: 4.01,
    width: 2.06,
    height: 13.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.08,6.72V8.83h-1a2.24,2.24,0,0,0-2.2,1.9,3,3,0,0,0,0,.49q0,3.09,0,6.17v.25H76.77v-.2c0-2.11,0-4.21,0-6.32a4.32,4.32,0,0,1,3.7-4.33,14.5,14.5,0,0,1,1.62-.08"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMotorola);
export default __webpack_public_path__ + "static/media/logo-motorola.8eeb38b9e2e0680fa2b161b67920b6d7.svg";
export { ForwardRef as ReactComponent };